import React from 'react'
import ActionButtons from './ActionButtons'
import { motion } from "framer-motion";

const slideInLeft = {
    hidden: { opacity: 0, x: -80 },
    visible: {
        opacity: 1,
        x: 0,
        transition: {
            duration: 0.8,
            ease: "easeOut",
        },
    },
};

const slideInRight = {
    hidden: { opacity: 0, x: 80 },
    visible: {
        opacity: 1,
        x: 0,
        transition: {
            duration: 0.8,
            ease: "easeOut",
        },
    },
};

const container = {
    hidden: {},
    visible: {
        transition: {
            staggerChildren: 0.2,
        },
    },
};

const HeroCTA1 = () => {
    return (
        <motion.div variants={container} initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.2 }} className='w-full bg-[#FFF7E8] rounded-[40px] flex flex-col md:flex-row items-center gap-5 justify-between pl-4 pr-4 pt-7 mt-8 md:pl-10 md:pr-0 md:pt-0'>
            <motion.div variants={slideInLeft} className='text-[#24201E]'>
                <h2 className="font-display-fran font-semibold text-5xl mb-5 md:mb-11">Send money, <br /> anywhere.</h2>
                <p className='text-xl mb-[72px] hidden md:block'>Pay your way with flexible options. Send money via bank transfer, mobile money (MTN, Vodafone, etc.), cryptocurrency, or instantly with your unique AfriPay Tag, no account numbers needed.</p>
                <ActionButtons />
            </motion.div>
            <motion.img variants={slideInRight} src="/images/hero-cta-img1.avif" alt="Hero CTA Image 1" width={400} className='hidden md:block' />
            <motion.img variants={slideInRight} src="/images/hero-cta-mobile-img1.avif" alt="Hero CTA Image 1" width={329} className='md:hidden block' />
        </motion.div>
    )
}

export default HeroCTA1